<div class="max-width-p nume-beneficiu medical">
  <app-notification-banner></app-notification-banner>
  <benefit-header-summary
    [headerText]="'BENEFIT_SUMMARY.HEADER_TITLE1' | translate"
    [smallText]="'BENEFIT_SUMMARY.HEADER_TITLE2' | translate"
  >
  </benefit-header-summary>

  <div class="card earnings-card">
    <div class="card-body container flex-column">
      <h5>{{ 'BENEFIT_SUMMARY.BENEFITS.TITLE' | translate }}</h5>
      <div class="benefit-wrapper" *ngIf="benefit">
        <div class="benefit-container d-flex ">
          <div class="image">
            <img [src]="benefit?.pictureUrl" alt="" role="presentation"/>
          </div>
          <div class="info">
            <div class="bold">{{ benefit?.name }}</div>
            <div>
              <span class="bold fs-12">{{
                'BENEFIT_SUMMARY.BENEFITS.SHIPPING_TYPE' | translate
              }}</span>
              {{ benefit?.shippingTypeLabel | translate }}
            </div>

            <div *ngIf="benefit.location">
              <span class="bold fs-12">{{
                'BENEFIT_SUMMARY.BENEFITS.CITY' | translate
              }}</span>
              {{ benefit.location }}
            </div>
          </div>
          <div class="quantity-counter-wrapper">
            <core-touchspin
              [numberValue]="1"
              [stepValue]="1"
              [minValue]="1"
              [maxValue]="10"
            ></core-touchspin>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="card earnings-card"
    *ngIf="benefit && benefit.beneficiaryAcceptedFlag"
  >
    <div class="card-body container flex-column">
      <h5>{{ 'BENEFIT_SUMMARY.BENEFICIARY.TITLE' | translate }}</h5>

      <div class="card-content-wrapper benefit-wrapper" *ngIf="beneficiaries?.length > 0">
        <div class="d-flex" >
          <div class="custom-control custom-checkbox">
            <input
              type="radio"
              [(ngModel)]="selectedBeneficiary"
              (change)="onBeneficiaryChange()"
              name="selectedBeneficiary"
              id="beneficiary-checkbox-0"
              value="0"
              class="custom-control-input"
              checked
            />
            <label
              class="custom-control-label"
              for="beneficiary-checkbox-0"
            ></label>
          </div>
          <label class="bold name" for="beneficiary-checkbox-0">
            {{ userName }}
          </label>
        </div>
        <ng-container *ngFor="let beneficiary of beneficiaries; let i = index">
          <div class="d-flex align-items-center" style="align-items: flex-start !important;">
            <div class="custom-control custom-checkbox">
              <input
                type="radio"
                [(ngModel)]="selectedBeneficiary"
                (change)="onBeneficiaryChange()"
                name="selectedBeneficiary"
                id="beneficiary-checkbox-{{i+1}}"
                [value]="beneficiary.id"
                class="custom-control-input"
              />
              <label
                class="custom-control-label"
                for="beneficiary-checkbox-{{i+1}}"
                title="{{ beneficiary?.fullName }}"
              ></label>
            </div>
            <div
              class="d-flex align-items-center"
              style="width: 100%; align-items: flex-start !important;"
            >
            <div>
              <div class="bold name">{{ beneficiary?.fullName }}</div>
              <label class="d-flex mobile fs-14" for="beneficiary-checkbox-{{i+1}}">
                <ul class="d-flex flex-column mt-8 column-spacer">
                  <li>
                    <span class="bold">{{
                      'BENEFIT_SUMMARY.BENEFICIARY.CNP' | translate
                    }}</span>
                    {{ maskCnp(beneficiary?.cnp) }}
                  </li>
                  <li class="mt-8">
                    <span class="bold">{{
                      'BENEFIT_SUMMARY.BENEFICIARY.CITY' | translate
                    }}</span>
                    {{ beneficiary?.city }}
                  </li>
                </ul>
                <ul class="d-flex flex-column mt-8">
                  <li>
                    <span class="bold">{{
                      'BENEFIT_SUMMARY.BENEFICIARY.EMAIL' | translate
                    }}</span>
                    {{ maskEmail(beneficiary?.email) }}
                  </li>
                  <li class="mt-8">
                    <span class="bold">{{
                      'BENEFIT_SUMMARY.BENEFICIARY.PHONE_NUMBER' | translate
                    }}</span>
                    {{ maskPhone(beneficiary?.phoneNumber) }}
                  </li>
                </ul>
              </label>
            </div>
            <div class="actions">
              <a
                href="javascript:void(0)"
                class="edit"
                (click)="addEditBeneficiary('edit', beneficiary)"
                title="{{ 'BENEFICIARY.EDIT_BTN' | translate}}"
              >
                <span class="ficon icon-edit feather"></span>
              </a>
              <a
                href="javascript:void(0)"
                class="delete"
                (click)="deleteBeneficiary(beneficiary)"
                title="{{ 'BENEFICIARY.DELETE_BTN' | translate}}"
              >
                <span class="ficon icon-trash-2 feather"></span>
              </a>
            </div>
          </div>
          </div>
        </ng-container>
      </div>

      <div class="benefit-wrapper" [hidden]="beneficiaries?.length > 0">
        <div class="fs-12">
          {{ 'BENEFIT_SUMMARY.BENEFICIARY.ADD_DETAILS' | translate }}
        </div>
      </div>

      <div class="benefit-wrapper add-b">
        <button class="btn btn-secondary" (click)="addEditBeneficiary('add')">
          <span class="ficon feather icon-user-plus"></span>
          {{ 'BENEFIT_SUMMARY.BENEFICIARY.ADD_BENEFICIARY' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="card" *ngIf="benefitIs24Pay">
    <div class="card-body">
      <h5>{{ 'TRANSPORT_24PAY.ACCOUNT_24PAY' | translate }}</h5>
      <div class="benefit-wrapper">
        <div [formGroup]="form24Pay" class="form-group">
          <div>{{'TRANSPORT_24PAY.BENEFIT_SUMMARY.ACCOUNT_24PAY_DESCRIPTION' | translate}}</div>
          <div class="mt-16" style="font-size: 13px">
            {{'TRANSPORT_24PAY.BENEFIT_SUMMARY.PHONE_NUMBER_LABEL' | translate}}
            <span class="bold">{{'TRANSPORT_24PAY.BENEFIT_SUMMARY.REGISTERED_INTO_LABEL' | translate}}</span>
          </div>
          <input type="text" class="form-control" formControlName="phoneNumber" style="width:50%">
          <span class="invalid-feedback" *ngIf="form24Pay.controls.phoneNumber?.errors">*{{'TRANSPORT_24PAY.BENEFIT_SUMMARY.PHONE_VALID' | translate}}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- tnt, R.Maria -->
  <div class="card documents" *ngIf="documents && documents.length > 0 && !this.isPensionOrInsurance(this.benefit)">
    <div class="card-body">
      <h5>{{ 'BENEFIT_SUMMARY.DOCUMENTS.TITLE' | translate }}</h5>
      <div class="benefit-wrapper">
        <div class="text">
          <div>{{ 'BENEFIT_SUMMARY.DOCUMENTS.SUBTITLE1' | translate }}</div>
          <div>{{ 'BENEFIT_SUMMARY.DOCUMENTS.SUBTITLE2' | translate }}</div>
        </div>
        <div class="d-flex fww-m align-left">
          <div class="column" *ngFor="let document of documents; let i = index">
            <a href="javascript:void(0)" (click)="showLegal(document)" >
              <div class="t-content" [ngClass]="document.checked ? 'read-wrapper' : 'unread-wrapper'">
                <span class="ficon feather icon-file-text"></span>
                <span class="fs-12"
                  >{{ document.benefitName }}
                  {{ 'BENEFIT_SUMMARY.DOCUMENTS.NUMBER' | translate }}
                  {{ i + 1 }}</span
                >
              </div>
            </a>
              <div *ngIf="!document.checked" class="document-badge unread-document" style="display:flex;">
                <div><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.63268 8.42851C8.81601 8.61185 8.81601 8.88685 8.63268 9.07018C8.54101 9.16185 8.44935 9.20768 8.31185 9.20768C8.17435 9.20768 8.08268 9.16185 7.99101 9.07018L5.56185 6.64102L3.13268 9.07018C3.04102 9.16185 2.94935 9.20768 2.81185 9.20768C2.67435 9.20768 2.58268 9.16185 2.49102 9.07018C2.30768 8.88685 2.30768 8.61185 2.49102 8.42851L4.92018 5.99935L2.49102 3.57018C2.30768 3.38685 2.30768 3.11185 2.49102 2.92852C2.67435 2.74518 2.94935 2.74518 3.13268 2.92852L5.56185 5.35768L7.99101 2.92852C8.17435 2.74518 8.44935 2.74518 8.63268 2.92852C8.81601 3.11185 8.81601 3.38685 8.63268 3.57018L6.20352 5.99935L8.63268 8.42851Z" fill="black"/>
                  <mask id="mask0_1705_553" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="2" y="2" width="7" height="8">
                  <path d="M8.63268 8.42851C8.81601 8.61185 8.81601 8.88685 8.63268 9.07018C8.54101 9.16185 8.44935 9.20768 8.31185 9.20768C8.17435 9.20768 8.08268 9.16185 7.99101 9.07018L5.56185 6.64102L3.13268 9.07018C3.04102 9.16185 2.94935 9.20768 2.81185 9.20768C2.67435 9.20768 2.58268 9.16185 2.49102 9.07018C2.30768 8.88685 2.30768 8.61185 2.49102 8.42851L4.92018 5.99935L2.49102 3.57018C2.30768 3.38685 2.30768 3.11185 2.49102 2.92852C2.67435 2.74518 2.94935 2.74518 3.13268 2.92852L5.56185 5.35768L7.99101 2.92852C8.17435 2.74518 8.44935 2.74518 8.63268 2.92852C8.81601 3.11185 8.81601 3.38685 8.63268 3.57018L6.20352 5.99935L8.63268 8.42851Z" fill="white"/>
                  </mask>
                  <g mask="url(#mask0_1705_553)">
                  <rect x="0.0625" y="0.5" width="11" height="11" fill="#8C919A"/>
                  </g>
                  </svg></div>
                  <div>{{ 'BENEFIT_SUMMARY.DOCUMENTS.UNREAD' | translate }}</div>
              </div>
              <div *ngIf="document.checked" class="document-badge read-document">
                <div><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.77148 5.99935C8.77148 5.72435 8.95482 5.54102 9.22982 5.54102C9.50482 5.54102 9.68815 5.72435 9.68815 5.99935V9.20768C9.68815 9.98685 9.09232 10.5827 8.31315 10.5827H1.89648C1.11732 10.5827 0.521484 9.98685 0.521484 9.20768V2.79102C0.521484 2.01185 1.11732 1.41602 1.89648 1.41602H6.93815C7.21315 1.41602 7.39648 1.59935 7.39648 1.87435C7.39648 2.14935 7.21315 2.33268 6.93815 2.33268H1.89648C1.62148 2.33268 1.43815 2.51602 1.43815 2.79102V9.20768C1.43815 9.48268 1.62148 9.66602 1.89648 9.66602H8.31315C8.58815 9.66602 8.77148 9.48268 8.77148 9.20768V5.99935ZM5.42565 7.23685L10.4673 2.19518C10.6507 2.01185 10.6507 1.73685 10.4673 1.55352C10.284 1.37018 10.009 1.37018 9.82565 1.55352L5.10482 6.27435L4.05065 5.22018C3.86732 5.03685 3.59232 5.03685 3.40898 5.22018C3.22565 5.40352 3.22565 5.67852 3.40898 5.86185L4.78398 7.23685C4.87565 7.32852 4.96732 7.37435 5.10482 7.37435C5.24232 7.37435 5.33398 7.32852 5.42565 7.23685Z" fill="black"/>
                  <mask id="mask0_1705_571" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="1" width="11" height="10">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.77148 5.99935C8.77148 5.72435 8.95482 5.54102 9.22982 5.54102C9.50482 5.54102 9.68815 5.72435 9.68815 5.99935V9.20768C9.68815 9.98685 9.09232 10.5827 8.31315 10.5827H1.89648C1.11732 10.5827 0.521484 9.98685 0.521484 9.20768V2.79102C0.521484 2.01185 1.11732 1.41602 1.89648 1.41602H6.93815C7.21315 1.41602 7.39648 1.59935 7.39648 1.87435C7.39648 2.14935 7.21315 2.33268 6.93815 2.33268H1.89648C1.62148 2.33268 1.43815 2.51602 1.43815 2.79102V9.20768C1.43815 9.48268 1.62148 9.66602 1.89648 9.66602H8.31315C8.58815 9.66602 8.77148 9.48268 8.77148 9.20768V5.99935ZM5.42565 7.23685L10.4673 2.19518C10.6507 2.01185 10.6507 1.73685 10.4673 1.55352C10.284 1.37018 10.009 1.37018 9.82565 1.55352L5.10482 6.27435L4.05065 5.22018C3.86732 5.03685 3.59232 5.03685 3.40898 5.22018C3.22565 5.40352 3.22565 5.67852 3.40898 5.86185L4.78398 7.23685C4.87565 7.32852 4.96732 7.37435 5.10482 7.37435C5.24232 7.37435 5.33398 7.32852 5.42565 7.23685Z" fill="white"/>
                  </mask>
                  <g mask="url(#mask0_1705_571)">
                  <rect x="0.0625" y="0.5" width="11" height="11" fill="#28C76F"/>
                  </g>
                  </svg></div>
                  <div>{{ 'BENEFIT_SUMMARY.DOCUMENTS.READ' | translate }}</div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="card"
    *ngIf="
      benefit &&
      benefit.shippingType !== shippingTypes.Voucher &&
      benefit.shippingType !== shippingTypes.CardRecharge &&
      benefit.shippingType !== shippingTypes.Email
    "
  >
    <div class="card-body">
      <h5>{{ 'BENEFIT_SUMMARY.ADDRESSES.SHIPPING_TITLE' | translate }}</h5>
      <div class="benefit-wrapper">
        <div
          class="address"
          *ngIf="!shippingAddresses || shippingAddresses.length === 0"
        >
          {{ 'BENEFIT_SUMMARY.ADDRESSES.NO_ADDRESS' | translate }}
        </div>
        <div
          class="address d-flex align-items-center"
          style="width: 100%; align-items: flex-start !important;"
          *ngFor="let address of shippingAddresses; let i = index"
        >
        <div class="d-flex align-items-center" style="align-items: flex-start !important;">
          <div class="custom-control custom-checkbox">
            <input
              type="radio"
              [(ngModel)]="selectedShippingAddress"
              name="selectedShippingAddress"
              id="shipping-checkbox-{{ address.id }}"
              [value]="address.id"
              class="custom-control-input"
              [checked]="i === 0"
            />
            <label
              class="custom-control-label"
              for="shipping-checkbox-{{ address.id }}"
              title="{{ address.street }}, {{ address.number }}, {{ address.staircase }}, {{ address.floor }}, {{ address.apartment }}, {{ address.apartment }}"
            ></label>
          </div>
          <div class="card-content-details" style="width: 100%; margin-top: auto;">
            <span class="bold">{{ address.contactPersonName }},
              {{ address.contactPersonPhoneNumber }}</span
            >
            <div>
              {{ 'BENEFIT_SUMMARY.ADDRESSES.STREET' | translate }}
              {{ address.street }},
              {{ 'BENEFIT_SUMMARY.ADDRESSES.NUMBER' | translate }}
              {{ address.number }},
              {{ 'BENEFIT_SUMMARY.ADDRESSES.STAIRCASE' | translate }}
              {{ address.staircase }},
              {{ 'BENEFIT_SUMMARY.ADDRESSES.FLOOR' | translate }}
              {{ address.floor }},
              {{ 'BENEFIT_SUMMARY.ADDRESSES.APARTMENT' | translate }}
              {{ address.apartment }},
              {{ 'BENEFIT_SUMMARY.ADDRESSES.BUILDING' | translate }}
              {{ address.apartment }}
            </div>
            <div>
              {{ 'BENEFIT_SUMMARY.ADDRESSES.CITY' | translate }}
              {{ address.city }},
              {{ 'BENEFIT_SUMMARY.ADDRESSES.COUNTY' | translate }}
              {{ address.county }},
              {{ 'BENEFIT_SUMMARY.ADDRESSES.ZIP_CODE' | translate }}
              {{ address.zipCode }}
            </div>
          </div>
        </div>
          <div class="actions">
            <a
              href="javascript:void(0)"
              (click)="addEditAddress('shipping', 'edit', address)"
              title="{{ 'ADDRESSES.EDIT_ADDRESS' | translate}}"
            >
              <span class="ficon icon-edit feather"></span>
            </a>
            <a
              href="javascript:void(0)"
              (click)="deleteAddress(address, 'shipping')"
              title="{{ 'ADDRESSES.DELETE_ADDRESS' | translate}}"
            >
              <span class="ficon icon-trash-2 feather"></span>
            </a>
          </div>
        </div>
        <div class="benefit-wrapper">
          <button class="btn btn-secondary" (click)="addEditAddress('shipping', 'add')">
            <span class="ficon feather icon-map-pin"></span>
            {{ 'BENEFIT_SUMMARY.ADDRESSES.ADD_ADDRESS' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="card"
    *ngIf="benefit && ((benefit.hasCreditCardAllowed()  && (usesDifferenceWithCard === true || isCardPayment)) || this.hasBillingAddress())"
  >
    <div class="card-body">
      <h5>{{ 'BENEFIT_SUMMARY.ADDRESSES.BILLING_TITLE' | translate }}</h5>
      <div class="benefit-wrapper">
        <div
          class="address"
          *ngIf="!billingAddresses || billingAddresses.length === 0"
        >
          {{ 'BENEFIT_SUMMARY.ADDRESSES.NO_BILLING_ADDRESS' | translate }}
        </div>
        <div
          class="address d-flex align-items-center"
          style="width: 100%; align-items: flex-start !important;"
          *ngFor="let address of billingAddresses; let i = index"
        >
        <div class="d-flex align-items-center" style="align-items: flex-start !important;">
          <div class="custom-control custom-checkbox">
            <input
              type="radio"
              [(ngModel)]="selectedBillingAddress"
              (ngModelChange)="onBillingAddressChange($event)"
              name="selectedBillingAddress"
              id="billing-checkbox-{{ address.id }}"
              [value]="address.id"
              class="custom-control-input"
              [checked]="i === 0"
            />
            <label
              class="custom-control-label"
              for="billing-checkbox-{{ address.id }}"
              title="{{ address.street }}, {{ address.number }}, {{ address.staircase }}, {{ address.floor }}, {{ address.apartment }}, {{ address.apartment }}"
            ></label>
          </div>
          <div class="card-content-details" style="width: 100%; margin-top: auto;">
            <span class="bold"
              >{{ address.contactPersonName }},
              {{ address.contactPersonPhoneNumber }}</span
            >
            <div>
              {{ 'BENEFIT_SUMMARY.ADDRESSES.STREET' | translate }}
              {{ address.street }},
              {{ 'BENEFIT_SUMMARY.ADDRESSES.NUMBER' | translate }}
              {{ address.number }},
              {{ 'BENEFIT_SUMMARY.ADDRESSES.STAIRCASE' | translate }}
              {{ address.staircase }},
              {{ 'BENEFIT_SUMMARY.ADDRESSES.FLOOR' | translate }}
              {{ address.floor }},
              {{ 'BENEFIT_SUMMARY.ADDRESSES.APARTMENT' | translate }}
              {{ address.apartment }},
              {{ 'BENEFIT_SUMMARY.ADDRESSES.BUILDING' | translate }}
              {{ address.apartment }}
            </div>
            <div>
              {{ 'BENEFIT_SUMMARY.ADDRESSES.CITY' | translate }}
              {{ address.city }},
              {{ 'BENEFIT_SUMMARY.ADDRESSES.COUNTY' | translate }}
              {{ address.county }},
              {{ 'BENEFIT_SUMMARY.ADDRESSES.ZIP_CODE' | translate }}
              {{ address.zipCode }}
            </div>
          </div>
        </div>
          <div class="actions">
            <a
              href="javascript:void(0)"
              (click)="addEditAddress('billing', 'edit', address)"
              title="{{ 'ADDRESSES.EDIT_ADDRESS' | translate}}"
            >
              <span class="ficon icon-edit feather"></span>
            </a>
            <a
              href="javascript:void(0)"
              (click)="deleteAddress(address, 'billing')"
              title="{{ 'ADDRESSES.DELETE_ADDRESS' | translate}}"
            >
              <span class="ficon icon-trash-2 feather"></span>
            </a>
          </div>
        </div>
        <div class="benefit-wrapper" style="padding-top: 0">
          <div *ngIf="processorIsRaiffeisen && selectedBillingAddress !== 0 && !isBillingContactNameSameAsUsername(); then nameMismatch else paddingBlock"></div>
          <ng-template #nameMismatch>
            <div class="invalid-feedback" style="min-height: 16px; margin-bottom: 0.25rem;">
              {{ 'RAIFFEISEN.BENEFIT_SUMMARY.NAME_MISMATCH' | translate }}
            </div>
          </ng-template>
          <ng-template #paddingBlock>
            <div style="height: 16px;" ></div>
          </ng-template>
          <button
            class="btn btn-secondary"
            (click)="addEditAddress('billing', 'add')"
          >
            <span class="ficon feather icon-map-pin"></span>
            {{ 'BENEFIT_SUMMARY.ADDRESSES.ADD_ADDRESS' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Raiffeisen benefit form section -->
  <div class="card" *ngIf="processorIsRaiffeisen">
    <div class="card-body">
      <h5>{{ 'RAIFFEISEN.ADDITIONAL_FORM' | translate }}</h5>
      <div class="benefit-wrapper">
        <div [formGroup]="formRaiffeisen" class="form-group">
          <div>{{ 'RAIFFEISEN.BENEFIT_SUMMARY.FORM_DESCRIPTION' | translate }}</div>
          <div
            *ngIf="selectedBillingAddress !== 0; else noBillingAddressSelectedMessage"
            class="mt-16"
            [innerHTML]="'RAIFFEISEN.BENEFIT_SUMMARY.WARNING_PHONE_NUMBER'
              | translate : {phoneNumber: this.getBillingAddress()?.contactPersonPhoneNumber }">
          </div>
          <ng-template #noBillingAddressSelectedMessage>
            <div class="mt-16">
              {{ 'RAIFFEISEN.BENEFIT_SUMMARY.NO_BILLING_ADDRESS_SELECTED' | translate }}
            </div>
          </ng-template>
          <div class="mt-16" style="font-size: 13px">{{ 'RAIFFEISEN.BENEFIT_SUMMARY.FORM_FIELDS.EMPLOYER' | translate }}</div>
          <input type="text" class="form-control" [formControlName]=RaiffeisenFormData.EMPLOYER style="width:75%">
          <div class="mt-16" style="font-size: 13px">
            {{ 'RAIFFEISEN.BENEFIT_SUMMARY.FORM_FIELDS.BRANCH' | translate }}
            <span class="text-danger">*</span>
          </div>
          <div class="d-flex align-items-center">
            <ng-select
              class="long-option-text-ng-select"
              appendTo="body"
              [items]="raiffeisenBranchesOptions"
              [closeOnSelect]="true"
              [formControlName]="RaiffeisenFormData.BRANCH"
              [searchable]="true"
              [searchFn]="raiffeisenBranchesSearchFn"
              style="width: 75%"
            >
              <ng-template ng-label-tmp let-item="item" let-clear="clear">
                {{ item.displayName }}
                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ item.displayName }}
              </ng-template>
            </ng-select>
            <a class="d-flex semi-bold dark-green text-right"
               style="cursor: pointer; margin-left: 10px; margin-right: 10px"
               title="{{ 'RAIFFEISEN.BENEFIT_SUMMARY.CLIPBOARD_ICON_TITLE' | translate }}"
               (click)="copyCurrentBranchAddress($event)"
            >
              <i data-feather="clipboard"></i>
            </a>
          </div>
          <div *ngIf="formRaiffeisen.controls.branch.errors?.required"
               class="invalid-feedback">
            {{'RAIFFEISEN.BENEFIT_SUMMARY.BRANCH_REQUIRED' | translate}}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card earnings-card" *ngIf="benefitTaxes">
    <div class="card-body container flex-column" *ngIf="benefit">
      <h5>{{ 'BENEFIT_SUMMARY.SUMMARY_TITLE' | translate }}</h5>


      <div class="benefit-wrapper mt-8" style="justify-content: space-between !important;">
        <div class="space-between flex-wrap align-items-center">
          <div class="c-title bold">
            <span *ngIf="translateService.currentLang == 'ro'">
              {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.VALUE' | translate }} {{benefit.benefitTypeLabel | translate}}
            </span>
            <span *ngIf="translateService.currentLang == 'en'">
              {{benefit.benefitTypeLabel | translate}} {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.VALUE' | translate }}
            </span>
          </div>
          <div class="dark-green bold " style="margin-right: none;">
            {{ benefitTaxes.amountWithVat | number: '1.2-2' }} RON
          </div>

        </div>
      </div>


      <ng-container *ngIf="isCardPayment && userCompanyInfo.pricingPlan === PricingPlan.FLEX">
        <div class="mt-8" style="width: 100%;">
          <div class="space-between flex-wrap">
            <app-tax-category-display class="w-100" category="0"></app-tax-category-display>
            <div class="c-title bold" role="button"
            tabindex="0" ngbTooltip="{{ 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.NO_TAXES_AND_FEES_TOOLTIP' | translate }}" openDelay="400" placement="auto">
              {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAXES_AND_FEES' | translate }}
              <svg width="17px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
              </svg>
            </div>
            <div class="dark-green" class="semi-bold">
              {{ 0 | number: '1.2-2' }} RON
            </div>
            <div class="dark-green semi-bold text-right w-100 font-small-2" *ngIf="hasCamTax">
              {{ benefitTaxes.camTaxValue | number: '1.2-2' }} RON
              {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.CAM_WITHHELD_FROM_BENEFITS_BUDGET' | translate }}
              <span
                placement="auto"
                [ngbTooltip]="camTaxTooltipKey | translate: camTaxTooltipParams"
                role="button"
                tabindex="0"
                [title]="camTaxTooltipKey | translate: camTaxTooltipParams">
                <svg width="17px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                </svg>
              </span>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!isCardPayment && userCompanyInfo.pricingPlan === PricingPlan.FLEX">
        <div class="mt-8" style="width: 100%;">
          <div class="space-between flex-wrap">
            <app-tax-category-display class="w-100" category="{{effectiveTaxCategory}}"></app-tax-category-display>
            <div class="c-title bold" role="button"
            tabindex="0" ngbTooltip="{{ (showTaxesForCompany ? taxAndFeesTooltipText : taxAndFeesTooltipText + '_HIDDEN') | translate }}" openDelay="400" placement="auto">
              {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAXES_AND_FEES' | translate }}
              <svg width="17px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
              </svg>
            </div>
            <div class="dark-green" [ngClass]="{'semi-bold' : benefitTaxes.taxDistributionType == 1}">
              <span *ngIf="showTaxesForCompany">
                {{ totalTaxAmount | number: '1.2-2' }} RON
              </span>
              <span class="font-small-2 tax-source text-right w-100" *ngIf="!showTaxesForCompany">{{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAX_FROM_EMPLOYEE' | translate }}</span>
            </div>
            <span class="font-small-2 tax-source text-right w-100" *ngIf="showTaxesForCompany">
              <span *ngIf="benefitTaxes.taxDistributionType == 3">
                {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAX_FROM_COMPANY' | translate }}
              </span>
              <span *ngIf="benefitTaxes.taxDistributionType == 2">
                {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAX_FROM_EMPLOYEE' | translate }}
              </span>
              <span *ngIf="benefitTaxes.taxDistributionType == 1">
                {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAX_FROM_BUDGET' | translate }}
              </span>
            </span>
            <div class="dark-green semi-bold text-right w-100 font-small-2" *ngIf="hasCamTax">
              {{ benefitTaxes.camTaxValue | number: '1.2-2' }} RON
              {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.CAM_WITHHELD_FROM_BENEFITS_BUDGET' | translate }}
              <span
                placement="auto"
                [ngbTooltip]="camTaxTooltipKey | translate: camTaxTooltipParams"
                role="button"
                tabindex="0"
                [title]="camTaxTooltipKey | translate: camTaxTooltipParams">
                <svg width="17px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                </svg>
              </span>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="mt-8 benefit-wrapper" *ngIf="!this.benefitIsSubscription">
        <div class="space-between">
          <h5 class="font-medium-3">
            {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.PAYMENT' | translate }}
          </h5>
          <div class="dark-green semi-bold font-medium-3">
            {{ totalAmountWithVat | number: '1.2-2' }} RON
          </div>
        </div>
      </div>
      <div class="benefit-wrapper tickets">
        <div class="space-between">
          <div class="c-title bold">
            {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TOTAL_PAYMENT' | translate }}
          </div>
          <div class="dark-green semi-bold font-medium-3">
            {{ amountWithCamTax | number: '1.2-2' }} RON
          </div>
        </div>
      </div>

      <ng-container *ngIf="isCardPayment">
        <div class="d-flex flex-column" *ngIf="!this.benefitIsSubscription" style="width: 100%;">
          <div class="space-between order-3" >
            <div class="c-title">
              {{ 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.WITH_CARD_SIMPLE' | translate }}
            </div>
            <div
              class="dark-green semi-bold"
            >
              {{ amountWithCamTax | number: '1.2-2'}} RON
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!isCardPayment">
        <div class="d-flex flex-column" *ngIf="!this.benefitIsSubscription" style="width: 100%;">
          <div class="space-between" *ngIf="isSalaryPayment">
            <div class="c-title">
              {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.FROM_SALARY' | translate }}
            </div>
            <div
              class="dark-green semi-bold"
            >
              {{ totalAmountWithVat | number: '1.2-2'}} RON
            </div>
          </div>
          <div [ngClass]="{'space-between order-2' : usesTransportBudget || usesProfessionalDevelopmentBudget, 'space-between': usesStandardBudget}" *ngIf="usesStandardBudget && amountFromStandardBudget > 0">
            <div class="c-title">
              {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.FROM_STANDARD_BENEFITS_BUDGET' | translate }}
            </div>
            <div
              class="dark-green semi-bold"
            >
              {{ amountFromStandardBudget | number: '1.2-2'}} RON
            </div>
          </div>
          <div [ngClass]="{'space-between order-1' : usesTransportBudget}" *ngIf="usesTransportBudget">
            <div class="c-title">
              {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.FROM_TRANSPORT_BENEFITS_BUDGET' | translate }}
            </div>
            <div
              class="dark-green semi-bold"
            >
              {{ amountFromTransportBudget | number: '1.2-2'}} RON
            </div>
          </div>
          <div [ngClass]="{'space-between order-1' : usesProfessionalDevelopmentBudget}" *ngIf="usesProfessionalDevelopmentBudget">
            <div class="c-title">
              {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.FROM_PROFESSIONAL_DEVELOPMENT_BENEFITS_BUDGET' | translate }}
            </div>
            <div
              class="dark-green semi-bold"
            >
              {{ amountFromProfessionalDevelopmentBudget | number: '1.2-2'}} RON
            </div>
          </div>
            <div class="space-between order-3" *ngIf="usesCashbackBudget">
                <div class="c-title">
                    {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.FROM_CASHBACK_BUDGET' | translate }}
                </div>
                <div
                        class="dark-green semi-bold"
                >
                    {{ amountFromCashbackBudget | number: '1.2-2'}} RON
                </div>
            </div>
          <div class="space-between order-3" *ngIf="usesDifferenceWithCard">
            <div class="c-title" role="button"
            tabindex="0" ngbTooltip="{{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.AMOUNT_DUE_INFO' | translate }}" openDelay="400" placement="auto">
              {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.AMOUNT_DUE' | translate }}
              <svg width="17px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
              </svg>
            </div>
            <div
              class="dark-green semi-bold"
            >
              {{differenceWithCard | number: '1.2-2'}} RON
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="card" *ngIf="this.benefitIsSubscription && this.subscriptionPayments">
    <div class="payments-statement">
      <div class="mounthly-paymnets">
        <h5>{{ 'SUBSCRIPTION_PAYMENT.PAYMENT_STATEMENT' | translate }}</h5>
      </div>
    </div>

    <div class="subscription-container">
      <app-subscription-payment-table
      [benefitType]="this.benefit.benefitTypeId"
      [benefitTaxCategory]="this.benefit.benefitTaxCategory"
      [payments]="this.subscriptionPayments"
      [taxDistributionSource]="this.userInfoDashboard.companyTaxDistribution"
      [monthlyBudget]="this.userInfoDashboard.monthlyBudget">
      </app-subscription-payment-table>
    </div>
  </div>

  <ng-container *ngIf="benefit && !isCardPayment && !isSalaryPayment && benefitIsAutoOrder">
    <app-auto-order-summary [benefitName]="benefit.name"
                            [beneficiaryId]="beneficiaryId"
                            [benefitId]="benefit.id"
                            [userId]="userInfoDashboard.id"
                            [fixedQuantity]="quantity"
                            [subdomain]="subdomain"
                            (autoOrderSettings)="onAutoOrderSettingsChanged($event)"
    ></app-auto-order-summary>
  </ng-container>

  <div #dynamicContainer class="card" *ngIf="hasDynamicFields()">
    <div class="card-body" [innerHTML]="benefit.dynamicAttributesSafeHtml"></div>
  </div>

  <div class="card" *ngIf="hasActiveCheckoutPolicy && (requiredDocuments.length > 0 || policyCheckboxes.length > 0 || policyRequiredFields.length > 0)">
    <div class="card-body">
      <h5>{{ 'BENEFIT_SUMMARY.CHECKOUT_POLICY.TITLE' | translate }}</h5>

      <div class="benefit-wrapper" *ngIf="policyCheckboxes.length > 0">
        <div class="bold mb-1">{{ 'BENEFIT_SUMMARY.CHECKOUT_POLICY.CONSENTS' | translate }}</div>
        <app-required-consents
          [checkboxes]="policyCheckboxes"
          (consentChange)="onRequiredConsentChange()"
        ></app-required-consents>
      </div>

      <div class="benefit-wrapper mt-2" *ngIf="policyRequiredFields.length > 0">
        <div class="bold mb-1">{{ 'BENEFIT_SUMMARY.CHECKOUT_POLICY.FIELDS' | translate }}</div>
        <app-required-fields
          [fields]="policyRequiredFields"
          [fieldErrors]="requiredFieldErrors"
        ></app-required-fields>
      </div>

      <div class="benefit-wrapper mt-2" *ngIf="requiredDocuments.length > 0">
        <div class="bold mb-1">{{ 'BENEFIT_SUMMARY.CHECKOUT_POLICY.DOCUMENTS' | translate }}</div>
        <div class="fs-12 mb-1">{{ getRequiredDocumentsInfoText() }}</div>
        <div class="policy-upload-block">
          <div class="container">
            <input
              type="file"
              accept="application/pdf"
              multiple
              (change)="selectPolicyFiles($event)"
            />
            <img src="../../../../../assets/images/icons/upload.svg" alt="">
            <div class="text-container">
              <p>{{ 'BENEFIT_SUMMARY.CHECKOUT_POLICY.UPLOAD_DESCRIPTION' | translate }}</p>
              <div>
                <div class="small-text">{{ 'BENEFIT_SUMMARY.CHECKOUT_POLICY.FILES_RESTRICTIONS' | translate }}</div>
                <div>.pdf</div>
              </div>
            </div>
          </div>

          <div class="files-list" *ngIf="selectedPolicyFiles.length > 0">
            <div class="single-file" *ngFor="let file of selectedPolicyFiles; let i = index">
              <img src="../../../../../assets/images/icons/document.svg" class="document" alt="file">
              <div class="info">
                <h4 class="name">{{ file?.name }}</h4>
                <div class="size">{{ formatBytes(file?.size) }}</div>
                <app-progress [progress]="file?.progress"></app-progress>
              </div>
              <div>
                <img src="../../../../../assets/images/icons/cancel.svg" class="delete" alt="file" (click)="deletePolicyFile(i)">
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex flex-column" *ngFor="let document of requiredDocuments">
          <div class="bold" *ngIf="document.uploadedFile?.name">
            {{ document.displayName }} - {{ document.uploadedFile?.name }}
          </div>
          <a
            *ngIf="document.documentUrl"
            class="btn btn-outline-primary btn-sm mt-1 mb-1"
            [href]="document.documentUrl"
            target="_blank"
            rel="noopener"
            download
          >
            {{ 'BENEFIT_SUMMARY.CHECKOUT_POLICY.DOWNLOAD_TEMPLATE' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="card earnings-card" >
    <div class="card-body container-flex-column-full">
      <div class="space-around mob-fdc">
        <app-error-messages
          [errorMessages]="errorMessages">
        </app-error-messages>
        <div class="container-flex-column-full">
          <button
            class="btn btn-primary"
            [disabled]="!canBeOrdered ||
              (benefitIs24Pay && form24Pay != null && form24Pay.invalid) ||
              (activeEventName && isGiftTypeBenefit && (cardPaymentBlocked || effectiveCardPaymentAmount > 0)) ||
              (hasActiveCheckoutPolicy && !isCheckoutPolicyComplete()) ||
              checkoutPolicyLoadFailed"
            (click)="postOrder()">
            <span class="ficon icon-arrow-right feather"></span>
            {{ isCardPayment ? ('BENEFIT_SUMMARY.CARD_PAYMENT' | translate) : ('BENEFIT_SUMMARY.FINISH_ORDER' | translate) }}
          </button>
          <div class="fs-12 mt-8" *ngIf="tosDocumentUrl !== null">
            {{ 'BENEFIT_SUMMARY.TERMS1' | translate }}
            <a href="{{ tosDocumentUrl }}" target="_blank">{{ 'BENEFIT_SUMMARY.TERMS2' | translate }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
